import React, { Component } from 'react'
import { Container } from 'react-bootstrap'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import { BRAND } from '../constants/appConstants'

class Search extends Component {
  constructor() {
    super()
    this.state = {
      query: ''
    }
  }
  submit(event) {
    event.preventDefault()
    const { query } = this.state
    this.props.history.push(`/results/${query}`)
  }

  handleQueryOnChange(event) {
    this.setState({ query: event.target.value })
  }

  componentDidMount() {
    const { query } = this.props.match.params
    if (query) {
      this.setState({ query })
    }
  }

  render() {
    const { title, brand } = this.props
    const { query } = this.state
    const searchPlaceholder = 'Typ het onderwerp van uw vraag...'
    const searchLabel = searchPlaceholder

    const iconClass = brand === BRAND.TOYOTA ? 'dxp-icon icon-Search-small' : 'icon icon-search'

    return (
      <section className="block-section bg-light search">
        <Container>
          <h2 className="h3">{title || 'Waarmee kunnen wij u helpen?'}</h2>

          <form onSubmit={event => this.submit(event)}>
            <div className="input-group">
              <label htmlFor="query" className="sr-only">{searchLabel}</label>
              <input
                type="search"
                name="query"
                id="query"
                value={query}
                placeholder={searchPlaceholder}
                className="form-control"
                onChange={event => this.handleQueryOnChange(event)}
              />
              <div className="input-group-append">
                <button
                  type="submit"
                  className="btn btn-primary"
                  title="Zoeken"
                >
                  <i className={iconClass}></i>
                  <span className="text-hide">Zoeken</span>
                </button>
              </div>
            </div>
          </form>
        </Container>
      </section>
    )
  }
}

const mapStateToProps = state => {
  const { knowledgeBaseFlatList } = state.knowledgeBase
  return { answers: knowledgeBaseFlatList }
}

export default withRouter(connect(mapStateToProps)(Search))
